import { Formik, Form } from "formik";
import TextField from "../components/common/TextField";
import Button from "../components/common/Button";
import { FaMapMarkedAlt } from "react-icons/fa";

interface CityFormProps {
  initialValues: any;
  validationSchema: any;
  onSubmit: (
    values: any,
    formikHelpers: {
      resetForm: () => void;
    }
  ) => Promise<void>;
  isLoading?: boolean;
}

const CityForm: React.FC<CityFormProps> = ({
  initialValues,
  validationSchema,
  onSubmit,
  isLoading,
}) => {
  return (
    <div className="w-full max-w-2xl mx-auto">
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={onSubmit}
        enableReinitialize
      >
        {({
          values,
          errors,
          touched,
          handleChange,
          handleBlur,
          isSubmitting,
        }) => (
          <Form className="flex flex-col gap-6">
            <div className="bg-white shadow rounded-lg p-6">
              <div className="flex items-center gap-3 mb-6 pb-4 border-b border-gray-100">
                <div className="p-2 bg-blue-50 text-primary rounded-lg">
                  <FaMapMarkedAlt className="text-xl" />
                </div>
                <div>
                  <h2 className="text-lg font-semibold text-gray-800">
                    Informations de la ville
                  </h2>
                  <p className="text-sm text-gray-500">
                    Détails et localisation
                  </p>
                </div>
              </div>

              <div className="grid grid-cols-1 gap-6">
                {/* City name */}
                <div>
                  <label
                    htmlFor="displayName"
                    className="block text-sm font-medium text-gray-700 mb-1"
                  >
                    Nom de la ville
                  </label>
                  <TextField
                    id="displayName"
                    value={values.displayName}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    errors={errors}
                    touched={touched}
                    placeholder="Ex: Paris"
                  />
                </div>

                {/* Coordinates */}
                <div>
                  <div className="flex justify-between items-center mb-1">
                    <label className="block text-sm font-medium text-gray-700">
                      Coordonnées Géographiques
                    </label>
                    <span className="text-xs text-gray-400">
                      Pour le centrage de la carte
                    </span>
                  </div>
                  <div className="grid grid-cols-2 gap-4">
                    <TextField
                      id="coordinates[0]"
                      value={values.coordinates[0]}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      errors={errors}
                      touched={touched}
                      placeholder="Longitude"
                    />
                    <TextField
                      id="coordinates[1]"
                      value={values.coordinates[1]}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      errors={errors}
                      touched={touched}
                      placeholder="Latitude"
                    />
                  </div>
                </div>
              </div>

              <div className="flex justify-end pt-6 border-t border-gray-100 mt-6">
                <Button
                  className="bg-primary text-white font-medium py-2.5 px-6 rounded-lg hover:bg-opacity-90 transition-all shadow-sm flex items-center gap-2 disabled:opacity-50 disabled:cursor-not-allowed"
                  disabled={isSubmitting || isLoading}
                  type="submit"
                >
                  {isLoading ? "Enregistrement..." : "Enregistrer la ville"}
                </Button>
              </div>
            </div>
          </Form>
        )}
      </Formik>
    </div>
  );
};

export default CityForm;
